import React               from 'react';
import { Route, Routes } from 'react-router-dom';
import { Activity }        from './Activity';

export const ActivityRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={<Activity />}
    />
    <Route
      path="all"
      element={<Activity />}
    />
  </Routes>
);
